import React, { createContext, useContext, useState } from 'react'

import { Social, Username } from './types'

type LoginContextProps = {
  setUsername: (u: Username) => void
  username: Username
  setSocial: (s: Social) => void
  social: Social
  setExistingSocialState: (v: boolean) => void
  existingSocialState: boolean
  setUsernameClicked: (v: boolean) => void
  usernameClicked: boolean
  eventId: string
  setEventId: (v: string) => void
}

type LoginProviderProps = {
  children: React.ReactNode
  initialEventId: string
  initialUsername?: Username
}

const Context = createContext<LoginContextProps | undefined>(undefined)

export const LoginProvider: React.FC<LoginProviderProps> = ({
  children,
  initialEventId,
  initialUsername
}) => {
  const [username, setUsername] = useState<Username>(initialUsername || '')
  const [social, setSocial] = useState<Social>({})
  const [existingSocialState, setExistingSocialState] = useState(false)
  const [usernameClicked, setUsernameClicked] = useState(false)
  const [eventId, setEventId] = useState(initialEventId)

  return (
    <Context.Provider
      value={{
        setUsername,
        username,
        setSocial,
        social,
        setExistingSocialState,
        existingSocialState,
        usernameClicked,
        setUsernameClicked,
        eventId,
        setEventId
      }}
    >
      {children}
    </Context.Provider>
  )
}

export const useLogin = (): LoginContextProps => {
  const context = useContext(Context)
  if (typeof context === 'undefined') {
    throw new Error('useLogin must be used with a LoginProvider')
  }
  return context
}
